import {gql} from "@apollo/client";

export const GET_REPORT_LISTING_FOR_WMS = gql`
    query ReportQuery($filters: ReportFileFiltersTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getReportFileListingForWms(filters: $filters, pageRequest: $pageRequest) {
            content{
                id
                type
                name
                reportDate
                status
                operatorId
                operatorName
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface WmsReportListResponse {
    getReportFileListingForWms: ReportFileListingResponseType;
}

export interface ReportFileListingResponseType {
    content: ReportFileType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface ReportFileType {
    id: string;
    type: number;
    code: string;
    name: string;
    reportDate: string;
    status: number;
    operatorId?: string;
    operatorName?: string;
}